import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      if (!sessionId) {
        navigate("/welcome", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.setItem("pd_token", data.token);
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/care", { replace: true });
      } catch (e) {
        toast.error(apiErrorMessage(e) || "Google sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0C1B33] text-white gap-4">
      <div className="w-10 h-10 rounded-full border-4 border-white/20 border-t-[#1D9E75] animate-spin" />
      <p className="font-head text-lg">Signing you in…</p>
    </div>
  );
}
